<template>
    <!-- 合作伙伴 -->
    <div class="partner">
        <img class="banner" width="100%" src="@/assets/img/partner_banner.png" alt="">
        <div class="banner2">
            <img width="181" src="@/assets/img/p1.png" alt="">
            <img width="151" src="@/assets/img/p2.png" alt="">
            <img width="200" src="@/assets/img/p3.png" alt="">
            <img width="269" src="@/assets/img/p4.png" alt="">
            <img width="299" src="@/assets/img/p5.png" alt="">
            <img width="259" src="@/assets/img/p6.png" alt="">
            <img width="300" src="@/assets/img/p7.png" alt="">
            <img width="260" src="@/assets/img/p8.png" alt="">
            <img width="308" src="@/assets/img/p9.png" alt="">
            <img width="204" src="@/assets/img/p10.png" alt="">
            <img width="294" src="@/assets/img/p11.png" alt="">
        </div>
        <div class="banner3">
            <img width="320" src="@/assets/img/p12.png" alt="">
            <img width="480" src="@/assets/img/p13.png" alt="">
            <img width="390" src="@/assets/img/p14.png" alt="">
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'Partner',
    props: {
    }
}
</script>
  
<style scoped>
.partner {
    padding-bottom: 150px;
}

.banner {
    margin-bottom: 50px;
}

.banner2 {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.banner3 {
    display: flex;
    align-items: center;
}

.banner2>img {
    margin-left: 10px;
    margin-bottom: 30px;
}
</style>
  